import React from 'react';
import {
  Box,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';

// COMPONENTS
import TariffPlanListItem from './TariffPlanTableRow';
import Loader from '../../../common/Loader';

const TariffPlanTable = ({
  tariffPlans = [],
  addNewTariffPlan,
  showSingleTariffPlan,
  isLoading = false,
}) => {
  if (isLoading) {
    return <Loader />;
  }

  return (
    <Box sx={{ mt: 4 }}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          mb: 2,
        }}>
        <Typography variant="h2">List of Tariff Plans</Typography>
        <Button
          variant="contained"
          color="secondary"
          onClick={addNewTariffPlan}>
          Add New
        </Button>
      </Box>

      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Tariff Plan Name</TableCell>
              <TableCell>Monthly Licensing Commitment</TableCell>
              <TableCell>Monthly Usage Commitment</TableCell>
              <TableCell>Included Messages</TableCell>
              <TableCell>Included Numbers</TableCell>
              <TableCell>Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {tariffPlans.map((plan) => (
              <TariffPlanListItem
                key={plan.tariff_plan_id}
                id={plan.tariff_plan_id}
                planName={plan.tariff_plan_name}
                monthlyLicCom={plan.commitment_recur}
                monthlyUsageCom={plan.commitment_usage}
                includedMessages={plan.included_messages}
                maxUsers={plan.max_users}
                planStatus={plan.plan_status_name}
                plan={plan}
                onClickName={showSingleTariffPlan}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default TariffPlanTable;
